var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', [_c('b-row', [_c('b-col', [_c('span', {
    staticClass: "text-grey1 mt-1 ml-0"
  }, [_vm._v("Order Medicine > Order With Prescription ")]), _c('b-card', {
    staticClass: "mt-4"
  }, [_c('h4', [_vm._v("Please upload a valid prescription.")]), _c('b-form-file', {
    attrs: {
      "state": Boolean(_vm.file1),
      "placeholder": "Please upload prescription here...",
      "drop-placeholder": "Drop file here..."
    },
    on: {
      "change": _vm.readLogo
    }
  }), _vm.file1 ? _c('div', [_c('div', [_c('hr'), _c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    staticClass: "rounded-circle tx-20",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function ($event) {
        _vm.file1 = null;
      }
    }
  }, [_vm._v("×")])], 1), _c('div', [_c('b-img', {
    staticClass: "my-2 image",
    attrs: {
      "src": _vm.file1,
      "center": ""
    }
  })], 1), _c('hr')]), _c('b-form-group', {
    staticClass: "my-3",
    attrs: {
      "label": "Select Items"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var ariaDescribedby = _ref.ariaDescribedby;
        return [_c('b-form-radio-group', {
          staticClass: "text-grey1",
          attrs: {
            "id": "radio-group-1",
            "options": _vm.options,
            "aria-describedby": ariaDescribedby,
            "name": "radio-options"
          },
          model: {
            value: _vm.selected,
            callback: function ($$v) {
              _vm.selected = $$v;
            },
            expression: "selected"
          }
        })];
      }
    }], null, false, 2195573492)
  }), _vm.selected == 'specificItem' ? _c('b-row', {
    staticClass: "my-3 medicine-sequence"
  }, [_c('b-col', {
    staticClass: "text-grey1",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("Enter Medicine Sequence :")]), _c('b-col', [_c('b-form-input', {
    attrs: {
      "placeholder": "1,3,4"
    },
    model: {
      value: _vm.selectedItem,
      callback: function ($$v) {
        _vm.selectedItem = $$v;
      },
      expression: "selectedItem"
    }
  })], 1)], 1) : _vm._e(), _c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: _vm.status,
      callback: function ($$v) {
        _vm.status = $$v;
      },
      expression: "status"
    }
  }, [_vm._v(" Call Back Required ")]), _c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    staticClass: "btn-color",
    on: {
      "click": function ($event) {
        _vm.$router.push({
          name: 'pharmacy-listing',
          params: {
            orderData: _vm.orderPrescriptionData()
          }
        });
      }
    }
  }, [_vm._v("Select Pharmacy")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }